import useTranslation from "@babackapp/translations/use-translation";
import { Card, CardContent, CardHeader } from "@babackapp/ui/components/card";
import EditPasswordForm from "@/pages/(app)/account-settings/components/edit-password-form.tsx";
import EditNameForm from "@/pages/(app)/account-settings/components/edit-name-form.tsx";
import EditPictureProfileForm from "@/pages/(app)/account-settings/components/edit-picture-profile-form.tsx";
import { MfaSettings } from "@babackapp/account-security/mfa-settings";
import { useAuth } from "@babackapp/auth-client/hooks";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/ui/components/alert";
import { ArrowLeft, ShieldAlert } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { useViewerSuperpowerAwaitsMfa } from "@/lib/rights/use-viewer-is-baback-team";

export default function AccountSettingsPage() {
  const t = useTranslation();
  const { user } = useAuth();
  const isSuperpowerAwaitingMfa = useViewerSuperpowerAwaitsMfa();
  // Also mounted outside any shop (BAB-3035), where no sidebar leads back.
  const { shopId } = useParams();

  if (!user) {
    return;
  }

  return (
    <div
      className={
        "py-16 px-16 flex flex-col space-y-4 items-center justify-center w-full"
      }
    >
      <div className={"w-full max-w-[800px] space-y-4"}>
        {!shopId && (
          <Link
            to="/"
            className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("misc.back")}
          </Link>
        )}
        <div className="flex flex-col gap-2 w-full">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {t("accountSettings.title")}
          </h3>
          <p className="text-sm leading-relaxed text-muted-foreground max-w-[500px]">
            {t("accountSettings.subtitle")}
          </p>
        </div>
        <Card className={"w-full"}>
          <CardHeader>Profile</CardHeader>
          <CardContent>
            <EditPictureProfileForm user={user!} />
            <EditNameForm user={user!} />
          </CardContent>
        </Card>
        <Card className={"w-full"}>
          <CardHeader>Password</CardHeader>
          <CardContent>
            <EditPasswordForm />
          </CardContent>
        </Card>
        <Card className={"w-full"}>
          <CardHeader>{t("accountSettings.mfa.title")}</CardHeader>
          <CardContent className="flex flex-col gap-4">
            {isSuperpowerAwaitingMfa && (
              <Alert variant="warning">
                <ShieldAlert className="h-4 w-4" />
                <AlertTitle>{t("superAdmin.mfaRequired.title")}</AlertTitle>
                <AlertDescription>
                  {t("superAdmin.mfaRequired.description")}
                </AlertDescription>
              </Alert>
            )}
            <MfaSettings />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
